import { FC, useMemo } from 'react'
import { MedicoDtoStatus } from '../../core/_models'
import { useFormik } from 'formik'
import { changeStatusOfEmpresas } from '../../core/_requests'
import { OptionsHelper, showAlert, showError, ButtonType } from '_metronic/helpers'
import {
  Button,
  FetchState,
  FormSelect,
  ListLoading,
  LoadingIndicator,
  useModal,
} from 'app/components'
import { useT } from '_metronic/i18n/Metronici18n'
import { UsuarioDtoVinculo } from 'app/modules/apps/admin/usuarios/usuarios-list/core/_models'
import { isVinculoMedicoAtivo, vinculosMedicos } from 'app/modules/auth/core/vinculos'

export const ProfissionalDeSaudeVinculoEmpresasModal: FC = () => {
  const { closeModal, fetchStates } = useModal()
  const { t } = useT()

  const { data: usuario } = (fetchStates['usuario'] || {}) as FetchState<UsuarioDtoVinculo>

  const empresaOptions = useMemo(() => {
    return OptionsHelper.createOptions(
      vinculosMedicos(usuario?.vinculos),
      'empresa.nomeFantasia',
      'empresa.id'
    )
  }, [usuario?.vinculos])

  const initialFormulario = {
    empresas: usuario
      ? usuario?.vinculos?.filter(isVinculoMedicoAtivo).map((vinculo) => ({
          label: vinculo.empresa?.nomeFantasia,
          value: Number(vinculo.empresa?.id),
        }))
      : [],
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialFormulario,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const empresasActive = values.empresas?.map((empresa) => Number(empresa.value))
        const empresasDeActive = usuario?.vinculos
          ?.filter(
            (vinculo) =>
              !values.empresas?.some((empresa) => empresa.value === Number(vinculo.empresa?.id))
          )
          .map((vinculo) => Number(vinculo.empresa?.id))

        if (empresasActive && empresasActive?.length > 0) {
          const dataActive: MedicoDtoStatus = {
            pessoa: usuario?.pessoa?.id as number,
            status: true,
            empresas: empresasActive,
          }
          await changeStatusOfEmpresas(dataActive)
        }

        if (empresasDeActive && empresasDeActive?.length > 0) {
          const dataInactive: MedicoDtoStatus = {
            pessoa: usuario?.pessoa?.id as number,
            status: false,
            empresas: empresasDeActive,
          }
          await changeStatusOfEmpresas(dataInactive)
        }

        await showAlert({
          title: 'Sucesso',
          text: 'Vínculos das instituições salvos com sucesso!',
          icon: 'success',
        })

        closeModal()
      } catch (error) {
        await showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormSelect
        formik={formik}
        name='empresas'
        options={empresaOptions}
        className='mb-3'
        entity='empresa_ativa'
        isMulti
        isRequired
      />

      <div className='d-flex justify-content-center mt-5'>
        <Button onClick={closeModal} className='btn-secondary me-3' disabled={formik.isSubmitting}>
          {t('common.cancel')}
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.save')}
        </Button>
      </div>
      {formik.isSubmitting && <ListLoading />}
    </form>
  )
}
